{
  "name": "abonamente",
  "version": "1.1.30",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "prebuild": "npm version patch",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.1",
    "@angular/cdk": "^20.2.4",
    "@angular/common": "^20.3.1",
    "@angular/compiler": "^20.3.1",
    "@angular/core": "^20.3.1",
    "@angular/forms": "^20.3.1",
    "@angular/material": "^20.2.4",
    "@angular/material-moment-adapter": "^20.2.4",
    "@angular/platform-browser": "^20.3.1",
    "@angular/platform-browser-dynamic": "^20.3.1",
    "@angular/router": "^20.3.1",
    "@fontsource/roboto": "^5.2.5",
    "@types/node": "^22.0.2",
    "crypto-js": "^4.2.0",
    "material-icons": "^1.13.14",
    "ng-qrcode": "^20.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.3.2",
    "@angular/cli": "^20.3.2",
    "@angular/compiler-cli": "^20.3.1",
    "@types/crypto-js": "^4.2.2",
    "@types/jasmine": "~5.1.0",
    "baseline-browser-mapping": "^2.11.13",
    "cypress": "^14.3.1",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.8.3"
  }
}
